export default __webpack_public_path__ + "static/media/sticker-J.baa40a46.png";